import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productsReducer from './slices/productsSlice';
import statusesReducer from './slices/statusesSlice';
import similarProductsReducer from './slices/similarProductsSlice';
import constantsReducer from './slices/constantsSlice';
import certificatesReducer from './slices/certificatesSlice';
import technicalSpecsReducer from './slices/technicalSpecsSlice';
import newWaveReducer from './slices/newWaveSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    statuses: statusesReducer,
    similarProducts: similarProductsReducer,
    constants: constantsReducer,
    certificates: certificatesReducer,
    technicalSpecs: technicalSpecsReducer,
    newWave: newWaveReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
